import { useState } from "react"

import { useGetDeployments, useGetSensorsCount } from "@/api/useDeployments"
import { getDate } from "@/helpers/date.helpers"
import { useQueryString } from "@/hooks/useQueryString"
import {
  getDeployments,
  getSensorsCount
} from "./useFiltersDeployments.selector"

import type { Filters } from "@/organisms/SmartSearch/types/options.types"

export const useDeployments = (filters: Filters) => {
  const paramsQueryString = useQueryString([
    "orderBy",
    "ascending",
    "descending",
    "daysAgo",
    ...filters.map(({ key }) => key)
  ])

  const context = useGetDeployments(paramsQueryString, {
    select: getDeployments
  })

  return context
}

export const useSensorsCount = () => {
  const today = getDate()
  const toDate = today.endOf("day").unix()
  const fromDate = today.subtract(30, "days").startOf("day").unix()
  const state = useState<{ key: string; label: string }>()

  const context = useGetSensorsCount(
    {
      fromDate,
      toDate,
      granularity: "daily",
      ...(state[0]?.label ? { environment: state[0].label } : {})
    },
    { select: getSensorsCount }
  )

  return [context, state] as const
}
